import React, { useEffect, useState } from 'react';
import { ReactFlow, Controls, Background, MarkerType } from '@xyflow/react';
import { edges, getEdgeData } from './edges';
import { nodes, getNodesData } from './nodes';
import '@xyflow/react/dist/style.css';
import MultipleTargetNode from './MultipleTargetNode';
import SingleTargetNode from './SingleTargetNode';
import CustomEdge from './CustomEdge';
import CustomMarker from './CustomMarker';


const nodeTypes = {
  multiTarget: MultipleTargetNode,
  singleTarget: SingleTargetNode,
};

const edgeTypes = {
  customEdge: CustomEdge,
};

const ProgressFlowChart = (props) => {
  const data = props.data;

  const [edgeResult, setEdgeResult] = useState([]);
  const [nodeResult, setNodeResult] = useState([]); // ✅ Corrected from useEffect to useState

  useEffect(() => {
    const edgeData = getEdgeData(data);
    setEdgeResult(edgeData);
    const nodesData = getNodesData(data);
    setNodeResult(nodesData);

  }, [data]);

  

  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <CustomMarker />
      <ReactFlow
        nodes={nodeResult.length ? nodeResult : nodes} // ✅ Fixed 'lenght' typo
        edges={edgeResult.length ? edgeResult : edges}
        // nodes={ nodes} 
        //  edges={edges}
        fitView={true}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        zoomOnScroll={false}
        zoomOnPinch={false}
        minZoom={0.8}
        maxZoom={0.8}
        panOnDrag={false}
      >
        {/* <Background />
        <Controls /> */}
      </ReactFlow>
    </div>
  );
};

export default ProgressFlowChart;
